<template>
  <!-- 底部导航 -->
  <div>
    <div class="navFooter">
      <div class="box1" v-if="false">
        <!-- <div class="item"
             v-for="(item,index) in footerList"
             :key="index">
          <div class="name">{{ item.name }}</div>
          <div class="word"
               v-for="(v,i) in item.value"
               :key="i"
               @click="openDetail(v)">{{ v.title }}</div>
        </div> -->
        <!-- <div class="item">
          <div class="name">配送方式</div>
          <div class="word">物流查询</div>
        </div>
        <div class="item">
          <div class="name">支付方式</div>
          <div class="word">在线支付</div>
          <div class="word">交易条款</div>
        </div>
        <div class="item">
          <div class="name">售后服务</div>
          <div class="word">价格保护</div>
          <div class="word">发票制度</div>
          <div class="word">退换货申请</div>
          <div class="word">取消订单</div>
          <div class="word">售后政策</div>
        </div>
        <div class="item">
          <div class="name">商家服务</div>
          <div class="word">商家管理规则</div>
          <div class="word">资质标准</div>
          <div class="word">入驻协议</div>
          <div class="word">入驻流程</div>
        </div> -->
      </div>
      <div class="box2">
        <div class="box">
          <span class="word" @click="getAboutInfo">关于我们</span>
          <!-- <div class="line"></div> -->
          <span class="word word2">手机铁建商城</span>
        </div>
        <div class="icp" @click="openUrl">备案号：豫ICP备16004618号</div>
      </div>
    </div>
    <!-- 详情 -->
    <div>
      <el-dialog :title="detail.title" :visible.sync="dialogVisible" width="70%" :before-close="handleClose">
        <div class="foot-detail">
          <div class="word" v-html="detail.content"></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">关 闭</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nav-footer',
  data() {
    return {
      footerList: [],
      dialogVisible: false,
      detail: {}
    }
  },
  mounted() {
    this.getFooterTitle()
  },
  methods: {
    openUrl() {
      window.open('https://beian.miit.gov.cn')
    },
    // 查看详情
    openDetail(item) {
      this.dialogVisible = true
      this.detail = item
    },
    // 关闭弹框
    handleClose() {
      this.dialogVisible = false
      this.detail = {}
    },
    // 获取pc底部标题
    getFooterTitle() {
      this.$api.mall.getFooterTitle().then((res) => {
        console.log(res, 'pc底部标题');
        if (res.code == 200) {
          this.footerList = res.data
        }
      })
    },
    // 获取关于我们
    getAboutInfo() {
      this.$api.mall.getAboutInfo({
        type: 2
      }).then((res) => {
        console.log(res, '关于我们');
        if (res.code == 200) {
          this.detail = res.data
          this.dialogVisible = true
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.navFooter {
  width: 100%;
  height: 147px;
  background: #F5F5F5;
  cursor: pointer;

  .box1 {
    width: 100%;
    padding: 40px 400px 47px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    border-bottom: 1px solid #cccccc;

    .item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .name {
        font-size: 14px;
        color: #4c4948;
        font-weight: bold;
      }

      .word {
        font-size: 14px;
        color: #666666;
        margin-top: 8px;
      }

      .word:first-child {
        margin-top: 14px;
      }
    }
  }

  .box2 {
    width: 100%;
    height: 144px;
    padding: 26px 200px;
    box-sizing: border-box;

    .box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .word {
        font-size: 14px;
        color: #747474;
      }

      .word2 {
        margin-left: 37px;
      }

      .line {
        width: 1px;
        height: 12px;
        background-color: #cccccc;
        margin: 0 16px;
      }
    }

    .icp {
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: #999999;
      margin-top: 20px;
    }
  }
}

.foot-detail {
  width: 100%;

  .word {
    width: 100%;

    img {
      width: 100%;
    }
  }
}
</style>